import { useEffect, useState } from 'react';
import { loginRequest } from './msalConfig';
import { AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { acquireTokenSilent, useMsalAccountChecker } from './useMsalUtils';

export const useMsalAccessToken = (): AuthenticationResult => {
  const [accessToken, setAccessToken] = useState<AuthenticationResult>({} as AuthenticationResult);
  const { account, instance, inProgress } = useMsalAccountChecker();
  const [shouldAcquireToken, setShouldAcquireToken] = useState<boolean>(true);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const triggerApiCall = async () => {
      if (inProgress !== InteractionStatus.None || !shouldAcquireToken) {
        return;
      }

      const authResult = await acquireTokenSilent({
        instance,
        account,
        ...loginRequest
      });

      if (!authResult?.accessToken) {
        return;
      }

      setAccessToken(authResult);
      setShouldAcquireToken(false);

      if (authResult.expiresOn) {
        const expirationTime = new Date(authResult.expiresOn).getTime();
        const currentTime = new Date().getTime();
        const timeUntilExpiration = expirationTime - currentTime + 1000;

        timeoutId = setTimeout(() => {
          setShouldAcquireToken(true);
        }, Math.max(timeUntilExpiration, 0));
      }
    };

    triggerApiCall();

    return () => {
      clearTimeout(timeoutId);
    };
  }, [shouldAcquireToken, account, instance, inProgress]);

  return accessToken;
};
